(function () {

  'use strict';

  function pxSynchronizeGroupsForm(IdpProviderService) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        callback: '&callback'
      },
      templateUrl: 'app/components/authenticationSettings/_synchronizeGroupsForm/synchronizeGroupsForm.template.html',
      link: function (scope) {

        scope.initialStep = angular.copy(scope.context?.step);

        scope.scimSync = {
          method: 'SCIM',
          authType: 'CLIENT_CREDENTIALS',
          submitting: false
        };

        scope.scheduledConfirmDisable = {
          confirm: false
        };

        scope.back = function () {
          scope.context.step = 'syncMethod';
        };

        scope.tokenEndpoint = function () {
          if (scope.context && scope.context.payload && scope.context.payload.tokenEndpoint) {
            return scope.context.payload.tokenEndpoint;
          }
          return IdpProviderService.tokenEndpoint();
        };

        scope.continueSyncMethod = function () {
          if (scope.scimSync.method === 'API') {
            if (scope.context && angular.isFunction(scope.context.acceptApiSync)) {
              scope.context.acceptApiSync();
            }
            return;
          }
          scope.context.step = 'authMethod';
        };

        scope.continueAuthMethod = function () {
          if (scope.scimSync.submitting) {
            return;
          }
          scope.scimSync.submitting = true;
          const authType = scope.scimSync.authType;
          IdpProviderService.enableScim(scope.context.enableScimUrl, authType)
            .then(function (response) {
              scope.context.authType = authType;
              scope.context.payload = response.data;
              scope.context.step = 'response';
            })
            .catch(function (error) {
              scope.callback();
              IdpProviderService.handleScimError(error);
            })
            .finally(function () {
              scope.scimSync.submitting = false;
            });
        };

        scope.copy = function (value) {
          IdpProviderService.copyValue(value);
        };

        scope.close = function () {
          scope.callback();
        };
      }
    };
  }

  pxSynchronizeGroupsForm.$inject = ['IdpProviderService'];

  angular
    .module('printix-admin')
    .directive('pxSynchronizeGroupsForm', pxSynchronizeGroupsForm);

})();
